import React from 'react';
import InfoTooltip from '../InfoTooltip';

const CostBox = ({ clinicalAssessmentCost, prescreeningCost, screeningCost, finalTP, prevalence, sensitivity, specificity, clinicalAssessmentTiming }) => {
  // Convert string values to numbers to ensure proper calculations
  const numFinalTP = Number(finalTP);
  const numPrevalence = Number(prevalence);
  const numSensitivity = Number(sensitivity);
  const numSpecificity = Number(specificity);
  const numClinicalAssessmentCost = Number(clinicalAssessmentCost);
  const numPrescreeningCost = Number(prescreeningCost);
  const numScreeningCost = Number(screeningCost);

  const sampleSizeStep1 = Math.ceil(numFinalTP / (numSensitivity * numPrevalence));
  const sampleSizeStep2 = Math.ceil((numSensitivity * numPrevalence + (1 - numSpecificity) * (1 - numPrevalence)) * sampleSizeStep1);

  const costsNoPrescreening = numClinicalAssessmentCost * numFinalTP / numPrevalence + numScreeningCost * numFinalTP / numPrevalence;
  
  const costsCustom = numPrescreeningCost * sampleSizeStep1 + numClinicalAssessmentCost * (clinicalAssessmentTiming === "before" ? sampleSizeStep1 : sampleSizeStep2) + numScreeningCost * sampleSizeStep2;
  const percentageDifference = ((costsCustom / costsNoPrescreening) - 1) * 100;

  // Fix sign for percentage difference display (show savings as negative percentage)
  const infoStyle = percentageDifference < 0 ? { color: 'green' } : { color: 'red' };
  const iconName = percentageDifference < 0 ? 'arrow-down' : 'arrow-up';

  return (
    <div className="p-3 card gradient2">
      <h4 className='d-flex'>Cost <InfoTooltip tooltipTextKey="tooltip_cost_box" color="white" /></h4>
      <div className="card-body">
        <div className="info" style={infoStyle}>
          <h5>${costsCustom.toLocaleString()}</h5>
          <h6>{Math.abs(percentageDifference).toFixed(2)}% <i className={`fas fa-${iconName}`}></i></h6>
        </div>
      </div>
    </div>
  );
};

export default CostBox;